
$(document.body).on("click", ".read-more-btn", function () {
	let more = $(this).attr("data-more-text");
	let less = $(this).attr("data-less-text");

	//Open block
	$(this).closest(".module-text").toggleClass("opened");

	//Update read more text
	if ($(this).hasClass("active")) {
		$(this).removeClass("active");
		$(this).find(".txt").text(more);
	}
	else {
		$(this).addClass("active");
		$(this).find(".txt").text(less);
	}
});